import { main } from '../iife'

main.subscribe('load', e => {

})

export default main
